module.exports = __webpack_public_path__ + "static/media/externalBarn_6.8f679f0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/barn/externalBarn_6.png
// module id = 1310
// module chunks = 3